import * as React from "react"
import TextField from "@mui/material/TextField"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogActions from "@mui/material/DialogActions"
import Button from "@mui/material/Button"
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete"

const filter = createFilterOptions()

export default function AutoCompleteUTMSource({
    options,
    handleSaveNewOption,
    onChange,
}) {
    const [value, setValue] = React.useState(null)
    const [open, toggleOpen] = React.useState(false)

    const handleClose = () => {
        setDialogValue({
            name: "",
            key: "",
        })
        toggleOpen(false)
    }

    const [dialogValue, setDialogValue] = React.useState({
        name: "",
        key: "",
    })

    const handleSubmit = (event) => {
        event.preventDefault()
        setValue({
            name: dialogValue.name,
            key: dialogValue.key,
        })
        handleSaveNewOption(dialogValue)
        handleClose()
    }

    React.useEffect(() => {
        const normalizedKey = dialogValue.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .replace(/[^a-z0-9 ]/g, "")
            .trim()
            .replace(/\s+/g, "-")

        setDialogValue({
            ...dialogValue,
            key: normalizedKey,
        })
    }, [dialogValue.name])

    return (
        <React.Fragment>
            <Autocomplete
                value={value}
                fullWidth
                onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                        setTimeout(() => {
                            toggleOpen(true)
                            setDialogValue({
                                name: newValue,
                                key: "",
                            })
                        })
                    } else if (newValue && newValue.inputValue) {
                        toggleOpen(true)
                        setDialogValue({
                            name: newValue.inputValue,
                            key: "",
                        })
                    } else {
                        setValue(newValue)
                        if (onChange) {
                            onChange(newValue) // ← envia para o pai
                        }
                    }
                }}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params)

                    if (params.inputValue !== "") {
                        filtered.push({
                            inputValue: params.inputValue,
                            name: `Adicionar "${params.inputValue}"`,
                        })
                    }

                    return filtered
                }}
                id="free-solo-dialog-demo"
                options={options}
                getOptionLabel={(option) => {
                    // for example value selected with enter, right from the input
                    if (typeof option === "string") {
                        return option
                    }
                    if (option.inputValue) {
                        return option.inputValue
                    }
                    return option.name
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                renderOption={(props, option) => {
                    const { key, ...optionProps } = props
                    return (
                        <li key={key} {...optionProps}>
                            {option.name}
                        </li>
                    )
                }}
                sx={{ pt: 1 }}
                freeSolo
                renderInput={(params) => (
                    <TextField {...params} label="UTM Source" />
                )}
            />
            <Dialog open={open} onClose={handleClose}>
                <form onSubmit={handleSubmit}>
                    <DialogTitle>Adicionar novo UTM Source</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Local de onde seus leads poderão acessar seu
                            formulário
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            value={dialogValue.name}
                            onChange={(event) => {
                                const name = event.target.value

                                setDialogValue({
                                    ...dialogValue,
                                    name,
                                })
                            }}
                            label="UTM Source"
                            type="text"
                            variant="standard"
                        />

                        <TextField
                            margin="dense"
                            id="name"
                            value={dialogValue.key}
                            onChange={(event) =>
                                setDialogValue({
                                    ...dialogValue,
                                    key: event.target.value,
                                })
                            }
                            label="Chave"
                            variant="standard"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancelar</Button>
                        <Button type="submit">Ok</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </React.Fragment>
    )
}
